import { useCallback, useEffect, useState } from 'react';

export const IFRAME_READY_TYPE = 'IFRAME_READY';

export const sendMessageToParent = <T>(type: string, payload: T, targetOrigin = '*') => {
  window.parent.postMessage({ type, payload }, targetOrigin);
};

type UseParentMessageOptions<T> = {
  type: string;
  validate: (data: unknown) => data is T;
  allowedOrigin?: string;
};

export const useParentMessage = <T>({ type, validate, allowedOrigin }: UseParentMessageOptions<T>) => {
  const [data, setData] = useState<T | undefined>(undefined);

  const handleMessage = useCallback(
    (event: MessageEvent) => {
      if (allowedOrigin && event.origin !== allowedOrigin) {
        return;
      }

      const message = event.data;

      if (message?.type !== type) {
        return;
      }

      if (validate(message.payload)) {
        setData(message.payload);
      }
    },
    [type, validate, allowedOrigin],
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleMessage]);

  useEffect(() => {
    sendMessageToParent(IFRAME_READY_TYPE, { expectedType: type });
  }, [type]);

  return data;
};
